document.addEventListener("DOMContentLoaded", () => {
  const titles = document.querySelectorAll(".faq-tabs__title-item");
  const tabs = document.querySelectorAll(".faq-tabs__item");

  function setActiveTab(target) {
    titles.forEach(t => t.classList.remove("active"));
    tabs.forEach(tab => tab.classList.remove("active"));

    const activeTitle = document.querySelector(`.faq-tabs__title-item[data-title="${target}"]`);
    const activeTab = document.querySelector(`.faq-tabs__item[data-tab="${target}"]`);

    if (activeTitle) activeTitle.classList.add("active");
    if (activeTab) activeTab.classList.add("active");
  }

  titles.forEach(title => {
    title.addEventListener("click", () => {
      const target = title.getAttribute("data-title");
      setActiveTab(target);
    });
  });

  if (titles.length > 0) {
    const firstTarget = titles[0].getAttribute("data-title");
    setActiveTab(firstTarget);
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const items = document.querySelectorAll('.faq-tabs__acc-item');

  items.forEach(item => {
    const trigger = item.querySelector('.faq-tabs__acc-title');
    const content = item.querySelector('.faq-tabs__acc-description');

    content.style.height = '0px';
    content.style.overflow = 'hidden';
    content.style.paddingBottom = '0px';

    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      items.forEach(otherItem => {
        const otherContent = otherItem.querySelector('.faq-tabs__acc-description');
        if (otherItem !== item) {
          otherItem.classList.remove('is-open');
          otherContent.style.height = '0px';
          otherContent.style.paddingBottom = '0px';
        }
      });

      if (isOpen) {
        content.style.height = '0px';
        content.style.paddingBottom = '0px';
        item.classList.remove('is-open');
      } else {
        item.classList.add('is-open');

        content.style.height = 'auto';
        const fullHeight = content.scrollHeight + 'px';
        content.style.height = '0px';

        requestAnimationFrame(() => {
          content.style.height = fullHeight;
          content.style.paddingBottom = '20px';
        });
      }
    });
  });
});